import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=8be7f594&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"
import style0 from "./Project.vue?vue&type=style&index=0&id=8be7f594&prod&lang=scss&scoped=true"
import style1 from "./Project.vue?vue&type=style&index=1&id=8be7f594&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be7f594",
  null
  
)

export default component.exports